import gql from 'graphql-tag'

export const GET_GPS = gql`
  query ImeiRegistration($filter: ImeiRegistrationFilterType) {
    imeiRegistration(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      imeiRegistration {
        data {
          vehicleId
          licensePlate
          odometer
          companyId
          companyName
          activeOn
          imei
          vendorType
          phoneNo
          deviceCode
          deviceName
          latitude
          longitude
          lastPacket
          motionStatus
          vehicleTypeId
          vehicleType
          startSubscription
          endSubscription
        }
        pagination {
          endCursor
          page
          show
          startCursor
          total
        }
      }
    }
  }
`
export const GET_DEVICES_TYPES = gql`
  query DeviceTypes($filter: GetDeviceTypeFilter) {
    deviceTypes(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deviceType {
        deviceCode
        deviceName
      }
    }
  }
`

export const REGISTER_IMEI_MUTATION_CREATE = gql`
  mutation RegisterFromImei($input: RegisterFromImeiInput!) {
    registerFromImei(input: $input) {
      registerFromImei {
        sensor {
          id
          vehicleType {
            vehicleTypeId
            companyId
            isActive
            manufacturer
            model
            type
            category
            transmissionType
            fuelType {
              fuelTypeId
              name
              category
            }
            tonnage
            volume
            fuelEfficiency
            icon
            hasRelation
            formattedVehicleType
          }
          vehicleGroup {
            id
            companyId
            name
          }
          vehicle {
            id
            companyId
            driver1Id
            driver2Id
            garageId
            tonnage
            volume
            fuelEfficiency
            fuelCapacity
            odometer
            status
            imei
            licensePlate
            vehicleTypeId
            vehicleType {
              vehicleTypeId
              companyId
              isActive
              manufacturer
              model
              type
              category
              transmissionType
              fuelType {
                fuelTypeId
                name
                category
              }
              tonnage
              volume
              fuelEfficiency
              icon
              hasRelation
              formattedVehicleType
            }
            thermoType
            boxType
            chassisNumber
            machineNumber
            carrosserie
            year
            hullNo
            idleDuration
            parkingDuration
          }
          vehicleId
          sensorCode
          pinCode
          rangeLo
          rangeHi
          alertLo
          alertHi
          alertIdleLo
          alertIdleHi
          requireEngine
        }
        vehicle {
          id
          companyId
          driver1Id
          driver2Id
          garageId
          tonnage
          volume
          fuelEfficiency
          fuelCapacity
          odometer
          status
          imei
          licensePlate
          vehicleTypeId
          vehicleType {
            vehicleTypeId
            companyId
            isActive
            manufacturer
            model
            type
            category
            transmissionType
            tonnage
            volume
            fuelEfficiency
            icon
            hasRelation
            formattedVehicleType
          }
          thermoType
          boxType
          chassisNumber
          machineNumber
          carrosserie
          year
          hullNo
          idleDuration
          parkingDuration
          door1
          door2
          company {
            id
            idleTimeout
            parkTimeout
            offlineTimeout
            fuelGainAlert
            fuelLossAlert
            isActive
            showGeocode
            name
            domainName
            logoUrl
            email
            phoneNo
            faxNo
            taxNo
            category
            publicApiKey
            publicApiTokenExpiry
            companyTag
            dsBase
            dsIntervalType
            dsInitialInterval
            dsInitialBonus
            dsInterval
            dsBonus
            dsCostBrake
            dsCostAccel
            dsCostOverspeed
            dsCostSharpturn
            dsMinScoreA
            dsMinScoreB
            dsMinScoreC
            dsMinScoreD
            vsms1Customer
          }
          vehicleStatus {
            vehicleId
            companyId
            driverId
            tripDriverId
            ip
            port
            lastPacket
            lastReceive
            lastMotion
            lastStatusChg
            driverChangeOn
            speed
            calculatedSpeed
            direction
            latitude
            longitude
            temperature
            fuel
            fuelFiltered
            fuelCapacity
            sumFuel
            tripFuel
            sumDistance
            tripDistance
            signalStrength
            battery
            sumDrivetime
            tripDrivetime
            sumDrivetimeFormatted
            tripDrivetimeFormatted
            harshBrakes
            harshAccels
            sharpTurns
            overspeeds
            fenceCtr
            door1Status
            door2Status
            refrigeratorStatus
            tripMaxspeed
            lastDoor1Data
            lastDoor1Alert
            lastDoor2Alert
            lastSpeedAlert
            lastSummary
            tripstartOn
            tripstartLong
            tripstartLat
            motionStatus
            calculatedMotionStatus
            timeInStatus
            licensePlate
            engineOn
            batteryAlarmSet
            gsmAlarmSet
            hullNo
            ptoStatus
          }
        }
      }
      errorCode
      errorName
      isSuccessful
      message
      status
    }
  }
`

export const REASSIGN_IMEI_MUTATION_UPDATE = gql`
  mutation ReassignImei($input: RegisterFromImeiInput!) {
    reassignImei(input: $input) {
      errorCode
      errorName
      isSuccessful
      message
      status
    }
  }
`
export const GET_CHANGE_HISTORY = gql`
  query DeviceAuditLogs($filter: DeviceAuditLogInput!) {
    deviceAuditLogs(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deviceAuditLogs {
        data {
          time
          identifier
          entity
          action
          detail
          user
          companyId
          object
          oldData
          newData
          actionType
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`
export const GET_MOVING_HISTORY = gql`
  query DeviceHistoriesPaginated($filter: DeviceHistoriesFilter) {
    deviceHistoriesPaginated(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deviceHistoriesPaginated {
        data {
          activeOn
          company {
            name
          }
          companyId
          imei
          inactiveOn
          licensePlate
          phoneNo
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const UPDATE_SUBSCRIPTION = gql`
  mutation UpdateResellerSubscription($input: UpdateResellerSubscriptionInput!) {
    updateResellerSubscription(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      resellerSubscription {
        imei
        startSubscription
        endSubscription
        subscriptionType
      }
    }
  }
`
